import React from "react";
import { Pie } from "react-chartjs-2";

const PieChart = ({ chartData, options, width, height }) => {
  return <Pie data={chartData} options={options} width={width} height={height} />;
};

export default PieChart;
